module.exports = __webpack_public_path__ + "images/aldb9e868eb3ae3e697eb89f11381ee08d3.png";